function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.4989,14.4781 L13.2499,15.4731 C13.0469,16.2841 12.1239,16.6751 11.3979,16.2631 C8.7699,14.7761 6.5649,12.6291 5.0029,10.0491 C4.6179,9.4121 4.8379,8.5811 5.5039,8.2481 L6.7789,7.6101 C7.2049,7.3981 7.4729,6.9631 7.4729,6.4881 L7.4729,2.2551 C7.4729,1.5621 6.9109,0.9991 6.2179,0.9991 L1.2579,0.9991 C0.5219,0.9991 -0.0461,1.6311 0.0029,2.3661 C0.6769,12.3321 8.6679,20.3231 18.6339,20.9971 C19.3689,21.0461 19.9999,20.4781 19.9999,19.7421 L19.9999,14.7821 C19.9999,14.0891 19.4379,13.5271 18.7449,13.5271 L14.7169,13.5271 C14.1409,13.5271 13.6389,13.9181 13.4989,14.4781",
  id: "path-1"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/phone.e57fe94a.svg";
export { SvgComponent as ReactComponent };